module.exports = __webpack_public_path__ + "static/media/16UNODC1.43154e35.jpg";